export class EstimateModel {
}

export class InvoiceTemplateModel {
		Id : number;
    TemplateId : number;
    Name : string;
    AccentColor : string;
    FontColor: string;
    ImageUrl: string;
    Status: number;
    UserId: number;
    LogoAlignment: string;

  public InvoiceTemplateModel() {
    this.Id = 0;
    this.Status = 0;
    this.LogoAlignment = 'Left';
  }
}


